import {
  IReportActionParamsBase,
  IReportDefaultSchemaState,
} from "../../models";
import { getReportColumnOrderState } from "./reports.grid.column-order.helpers";
import { getReportVisibilityState } from "./reports.grid.column-visiblitiy.helpers";

/**
 * The report's default column layout — the very state the grid renders right after a fetch: the
 * selection, order and sorting saved on the report, with the currently applied grouping columns
 * leading. This is what "Reset to Default View" restores once the user reorders, hides or re-sorts
 * columns (RYDE-7873). `isSameReportRender` is deliberately not forwarded: a reset always overwrites
 * the current state, it never preserves it.
 */
export const getReportDefaultSchemaState = ({
  reportApiDto,
  fetchCriteria,
}: IReportActionParamsBase): IReportDefaultSchemaState => ({
  columnsOrder: getReportColumnOrderState({ reportApiDto, fetchCriteria }),
  columnsVisibility: getReportVisibilityState({ reportApiDto, fetchCriteria }),
  columnsSorting: reportApiDto.report?.clientColumnSort ?? [],
});
